import React from "react"
import { Tab, VStack, Container, Box, Flex, Text } from "@chakra-ui/react"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { chatCountAtom, chatIsReadAtom } from "../../../recoil/atoms/chats"
import layoutStates from "../../../recoil/atoms/layout"
import { TabIconRenderProps } from "../services-tab-list/services-tab-list.interface"

const ChatCountTabIcon = ({
  index,
  tabButtonStyle,
  el,
  handleOnClick
}: TabIconRenderProps) => {
  const chatIsRead = useRecoilValue(chatIsReadAtom)
  const chatCount = useRecoilValue(chatCountAtom)
  const setChatTab = useSetRecoilState(layoutStates.isChatTab)

  const handleChatTab = React.useCallback(
    el => {
      handleOnClick(el)
      setChatTab(true)
    },
    [handleOnClick, setChatTab]
  )

  return (
    <Tab
      key={index}
      onClick={() => handleChatTab(el)}
      {...tabButtonStyle}
      bg="transparent"
    >
      <VStack margin="4px 0px">
        <Container p="0" centerContent pos="relative">
          <Flex position="relative">
            {el.icon}
            {!chatIsRead && chatCount !== 0 && (
              <Box
                width={"8px"}
                height={"8px"}
                borderRadius="50%"
                background={"red"}
                position="absolute"
                top="-2px"
                right="-2px"
              ></Box>
            )}
          </Flex>

          <Text
            fontSize={chatCount > 99 ? "0.4rem" : "0.5rem"}
            p="0"
            m="0"
            pos="absolute"
            left={chatCount > 99 && "8.5px"}
            bottom={chatCount > 99 ? "4.5px" : "3.5px"}
          >
            {chatCount > 99 ? 99 : chatCount}
          </Text>
          {chatCount > 99 && (
            <Text
              position="absolute"
              fontSize={"0.5rem"}
              p="0"
              m="0"
              right="7px"
              top="2px"
            >
              +
            </Text>
          )}
        </Container>
        <Container
          p="0"
          centerContent
          marginTop="0.2rem !important"
          marginBottom="0.1rem !important"
        >
          <Text
            fontSize={el.text.length > 9 ? "11px" : "13px"}
            display="inline"
            lineHeight={1}
            fontWeight="medium"
          >
            {el.text}
          </Text>
        </Container>
      </VStack>
    </Tab>
  )
}

export default ChatCountTabIcon
